import React, { Component } from 'react'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { withRouter } from "react-router-dom";
import { inject } from 'mobx-react';
import moment from 'moment'
import config from 'react-global-configuration';

import AcceptContractPopup from '../internal/Popups/AcceptContractPopup';

class ContractTable extends Component {

  constructor(props) {
      super(props)
      this.state = {
          data: this.props.data,
          showmodal: false,
          contract: "",
      }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data)
      this.setState({ data: this.props.data })
  }

  sortDates = (a, b, order) => {
    let indices = [6, 7, 8, 9, 3, 4, 0, 1];
    if (order === 'asc') {
      let r = 0;
      indices.find(i => r = a.date.charCodeAt(i) - b.date.charCodeAt(i));
      return r;
    } else if (order === 'desc') {
      let r = 0;
      indices.find(i => r = b.date.toString().charCodeAt(i) - a.date.toString().charCodeAt(i));
      return r;
    }
  }

  onRowClick = row => {
    if(this.props.onRowClick === "details")
      this.props.history.push(`/internal/admin/contracts/${row.objectId}`);
  }

  addAcceptLink = (cell, row) => {
    return row.acceptedRaw || row.archived ? cell : (<div>{ cell } - <a style={{cursor: "pointer"}} onClick={() => { this.setState({ showmodal: true, contract: { id: row.objectId } } )}}>Akzeptieren</a></div>);
  }

  addContractLink = (cell, row) => {
    return (<div><a href={cell} target="_blank" style={{cursor: "pointer"}}>Anzeigen</a></div>);
  }

  render() {
    const contracts = this.state.data;
    const hidden = this.props.hide ? this.props.hide : [];

    if(!(contracts != null && contracts.length > 0))
      return <p style={{color: "#000000"}}>Keine Verträge</p>

    let contractItems = []

    contracts.map((contract, idx) => {
      let date = new Date(contract.createdAt)
      contractItems.push({
        objectId: contract.objectId,
        acceptedRaw: contract.isAccepted,
        archived: contract.isArchived,
        accepted: contract.isArchived ? "Archiviert" : contract.isAccepted ? "Bestätigt ✔" : "Nicht bestätigt ✘",
        year: contract.year,
        date: moment(contract.createdAt).locale("en").format('DD/MM/YYYY'),
        link: config.get('CLOUDINARY_URL') + contract.url,
        fee: "€ " + contract.fee,
        company: contract.company ? contract.company.name : "-",
      })
    })

    return (
      <div>
        <BootstrapTable data={ contractItems } borderless={true} options={{ onRowClick: this.onRowClick, defaultSortName: 'date', defaultSortOrder: 'desc' }} hover={true} pagination={this.props.pagination} search={this.props.search} bodyStyle={{cursor: this.props.onRowClick ? "pointer" : ""}}>
          <TableHeaderColumn dataField="objectId" isKey>ID</TableHeaderColumn>
        { !hidden.includes("company") &&
          <TableHeaderColumn dataField="company" dataSort>Firma</TableHeaderColumn> }
        { /*!hidden.includes("year") &&
          <TableHeaderColumn dataField="year" dataSort={true}>Jahr</TableHeaderColumn> */}
        { !hidden.includes("date") &&
          <TableHeaderColumn dataField="date" dataSort={true} sortFunc={this.sortDates}>Datum</TableHeaderColumn> }
        { !hidden.includes("fee") &&
          <TableHeaderColumn dataField="fee" dataSort>Beitrag</TableHeaderColumn> }
        { !hidden.includes("accepted") &&
          <TableHeaderColumn dataField="accepted" dataFormat={hidden.includes("acceptLink") ? cell => cell : this.addAcceptLink} dataSort={true}>Status</TableHeaderColumn> }
        { !hidden.includes("link") &&
          <TableHeaderColumn dataField="link" dataFormat={this.addContractLink}>Vertrag</TableHeaderColumn> }
        </BootstrapTable>

        <AcceptContractPopup
          ref={instance => { this.popup = instance }}
          open={this.state.showmodal}
          accepted={(id) => this.setState({showmodal: false, contract: {id: null}})}
          reopen={true}
          contract={this.state.contract}
        />
      </div>
    )
  }
}

export default withRouter(ContractTable)



// WEBPACK FOOTER //
// /src/components/Tables/ContractTable.js